import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout from "./PolicyLayout";
import { POLICY_LINKS } from "../config/policyLinks";

function PolicyIndex() {
  return (
    <PolicyLayout title="Policy Centre" intro="Use this directory to find the rules for data, ordering, payment, delivery, returns and safe use of the goods currently sold on this storefront.">
      <section className="policy-directory" aria-labelledby="policy-directory-heading">
        <h2 id="policy-directory-heading">Store policies</h2>
        <ul>{POLICY_LINKS.filter(([, path]) => path !== "/policies").map(([label, path]) => <li key={path}><Link to={path}>{label}</Link></li>)}</ul>
      </section>
      <section><h2>How the policies work together</h2><p>The Terms of Use govern browsing. The Terms of Sale govern an order. The product, shipping, parcel, cancellation and returns pages add rules for their specific stages. Privacy, data-rights and storage pages explain information handling. If a mandatory consumer right gives stronger protection, that protection continues to apply.</p></section>
    </PolicyLayout>
  );
}

export default PolicyIndex;
